var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.salespersonSalePaymentData)?_c('div',[_c('ColumnChart',{attrs:{"title":'Plasiyer Tahsilat Analiz Grafiği',"description":'Plasiyer Bazlı Tahsilat Grafiği',"column-chart-options":_vm.salespersonPaymentDataChartOptions,"loading":_vm.salespersonSalePaymentDataLoading}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }